import { Component } from '@angular/core';
import { PillarPagesTemp } from '../../components/pillar-pages-temp/pillar-pages-temp';

@Component({
  selector: 'app-advanced-manufacturing',
  imports: [PillarPagesTemp],
  templateUrl: './advanced-manufacturing.html',
  styleUrl: './advanced-manufacturing.scss',
})
export class AdvancedManufacturing {

}
